import axios from '@/plugins/axios';
import {
  Invoice, InvoiceItem, PayloadAttachment, PayloadCancel,
  PayloadCreateInvoice, PayloadExtendInvoice, PayloadUpdateInvoice, PayloadUpdateReadDateInvoice
} from '@/models/Invoice';

export async function getInvoice(invoiceId: string) {
  return (await axios.get(`/v1/invoices/${invoiceId}`)).data;
}

export async function getInvoices(): Promise<Invoice[]> {
  return (await axios.get('/v1/invoices')).data;
}

export async function createInvoice(payload: PayloadCreateInvoice): Promise<Invoice> {
  return (await axios.post('/v1/invoices', payload)).data;
}

export async function updateInvoice(invoiceId: string, payload: PayloadUpdateInvoice) {
  return (await axios.put(`/v1/invoices/${invoiceId}`, payload)).data;
}

export async function deleteInvoice(invoiceId: string) {
  return (await axios.delete(`/v1/invoices/${invoiceId}`)).data;
}

export async function extendInvoice(invoiceId: string, payload: PayloadExtendInvoice) {
  return (await axios.put(`/v1/invoices/${invoiceId}/extend`, payload)).data;
}

export async function paidInvoice(invoiceId: string) {
  return (await axios.put(`/v1/invoices/${invoiceId}/paid`)).data;
}

export async function sendInvoice(invoiceId: string) {
  return (await axios.put(`/v1/invoices/${invoiceId}/send`)).data;
}

export async function viewInvoice(invoiceId: string) {
  return (await axios.get(`/v1/invoices/${invoiceId}/view`)).data;
}

export async function cancelInvoice(invoiceId: string, payload: PayloadCancel) {
  return (await axios.put(`/v1/invoices/${invoiceId}/cancel`, payload)).data;
}

export async function updateReadDateInvoice(invoiceId: string, readDate: PayloadUpdateReadDateInvoice) {
  return (await axios.put(`/v1/invoices/${invoiceId}/readDate`, readDate)).data;
}

export async function checkInvoice(invoiceId: string) {
  return (await axios.get(`/v1/invoices/${invoiceId}/check`)).data;
}

//
// ------------------- Positions -------------------------------
//

export async function updatePosition(invoiceId: string, payload: InvoiceItem[]) {
  return (await axios.put(`/v1/invoices/${invoiceId}/item`, payload)).data;
}

//
// ------------------- Attachment -------------------------------
//

export async function getAttachment(attachmentId: string) {
  return (await axios.get(`/v1/invoice/attachments/${attachmentId}`)).data;
}

export async function addAttachment(invoiceId: string, payload: PayloadAttachment) {
  return (await axios.post(`/v1/invoice/${invoiceId}/attachments`, payload)).data;
}

export async function deleteAttachment(invoiceId: string, attachmentId: string) {
  return (await axios.delete(`/v1/invoice/${invoiceId}/attachments/${attachmentId}`)).data;
}
